// src/store/slices/skillSlice.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createGenericSlice } from './genericSliceFactory';
import { apiMethods } from '../../services/api';
import type { Skill, ApiResponse } from '@/types';

const skillSlice = createGenericSlice<Skill>({
    name: 'skills',
    endpoint: '/skills',
});

export const {
    setCurrentItem: setCurrentSkill,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = skillSlice.actions;

export const {
    fetchActive: fetchActiveSkills,
} = skillSlice.thunks;

// ── Public endpoints ──────────────────────────────────────────────────────────

/**
 * GET /skills/by-category?lang=en
 * Public — skills grouped by category. The response is a map of category name to
 * skills, not a flat list, and the API accepts only `lang`; sending `category`
 * was rejected outright by its query validation.
 */
export const fetchSkillsByCategory = createAsyncThunk(
    'skills/fetchByCategory',
    async (lang: 'ar' | 'en' = 'en', { rejectWithValue }) => {
        try {
            const response = await apiMethods.get<ApiResponse<Record<string, Skill[]>>>(
                `/skills/by-category?lang=${encodeURIComponent(lang)}`
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch skills by category');
        }
    }
);

export default skillSlice.reducer;